import { atom } from "recoil";

export const nodesVisibleInAttackGraphState = atom<string[]>({
  key: "nodesVisibleInAttackGraphState",
  default: [],
});

// export default nodesVisibleInAttackGraphState;
